"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = exports.useUpdate = exports.usePageView = exports.useEngagement = exports.useEvent = exports.update = exports.pageView = exports.engagement = exports.event = exports.bufferIfNecessary = exports.bufferedEvents = void 0;

var _react = require("react");

var _fetchAd3 = _interopRequireWildcard(require("./fetchAd"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var bufferedEvents = [];
exports.bufferedEvents = bufferedEvents;
var fieldsToWipe = {};
var persistentFields = {};

var isServerside = function isServerside() {
  return typeof window === 'undefined';
};

var isAd = function isAd(ad) {
  return ad && (ad === null || ad === void 0 ? void 0 : ad.adId);
};
/**
 * Dispatches the event. It is the callers responsibility to make sure everything is in order,
 * `window.datalayer` exists, we are in a browser, etc, before calling this function.
 */


var callImmediately = function callImmediately(payload) {
  /**
   * GTM stores all key: values in a event and adds them to the next event *unless* we send in
   * `undefined` as the value for the key in the following event.
   *
   * We will store the current events keys, create a object with `undefined` values for all the keys
   * and then merge the next payload with the wipe object.
   */
  var newFieldsToWipe = Object.keys(payload).reduce(function (obj, key) {
    obj[key] = undefined;
    return obj;
  }, {});
  payload = _objectSpread(_objectSpread({}, fieldsToWipe), payload);
  fieldsToWipe = newFieldsToWipe || {};
  window.dataLayer.push(payload);
};

var sendBufferedEvents = function sendBufferedEvents() {
  bufferedEvents.forEach(callImmediately); // Clear the buffer, this syntax is hideous but it is the only way to clear the array without
  // repeated `.pop` calls or removing the const modifier on the instance.

  bufferedEvents.length = 0;
};

var setup = function setup(bearerToken, blocketApiUrl, credentials, trackingId) {
  (0, _fetchAd3.setup)(bearerToken, blocketApiUrl, credentials);

  if (window.dataLayer) {
    sendBufferedEvents();
    return;
  }

  var script = document.createElement('script');
  /**
   * `window.dataLayer` will never be set so this is a bit redundant, it is a extra precaution in
   * case anyone removes the `if (window.dataLayer) return` that we currently have earlier in this
   * function.
   */

  window.dataLayer = window.dataLayer || [];
  script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(trackingId, "');");
  document.getElementsByTagName('head')[0].appendChild(script);
  sendBufferedEvents();
};

exports.setup = setup;

var addAdAndSend = function addAdAndSend(event, payload, ad) {
  /**
   * In some cases the ad might be something unexpected, lets take some extra precautions.
   * The default empty object is there to avoid a infinite loop since `bufferIfNecessary` can
   * trigger a ad fetch if the payload doesn't have a ad.
   */
  payload.ad = isAd(ad) ? ad : {};
  /**
   * This function is called by `bufferIfNecessary`, disable the "don't use before defined" but lets
   * make sure this functions is defined right before `bufferIfNecessary`.
   */
  // eslint-disable-next-line no-use-before-define

  bufferIfNecessary(event, payload);
};
/**
 * Takes a event type and a payload and either dispatch the event immediatly or buffer it until the
 * GTM tracker is setup.
 */


var bufferIfNecessary = function bufferIfNecessary(event, payload) {
  var _payload;

  if (!payload || isServerside()) {
    /**
     * Ignore the event if we are serverside or the payload is falsy.
     */
    return;
  }

  payload = _objectSpread(_objectSpread({
    event: event
  }, persistentFields), payload);

  if (isAd((_payload = payload) === null || _payload === void 0 ? void 0 : _payload.ad)) {
    /**
     * Nothing should rely on the `adId`/`listId` fields if we have a proper ad. The fields can be
     * undefined if they are going to be purged in the event so we have to do a truthiness check.
     */
    delete payload.adId;
    delete payload.listId;
    var _payload2 = payload,
        ad = _payload2.ad;

    if (!payload.categories) {
      var _ad$category;

      payload.categories = ad === null || ad === void 0 ? void 0 : (_ad$category = ad.category) === null || _ad$category === void 0 ? void 0 : _ad$category.map(function (_ref) {
        var name = _ref.name;
        return name;
      });
    }

    if (!payload.regions) {
      var _ad$location;

      payload.regions = ad === null || ad === void 0 ? void 0 : (_ad$location = ad.location) === null || _ad$location === void 0 ? void 0 : _ad$location.map(function (_ref2) {
        var name = _ref2.name;
        return name;
      });
    }
  }
  /**
   * We are not going to check if we have a "real" ad object here, it is fine if it is a empty
   * object since we use that as a escape hatch to avoid ending up in a loop of fetch > missing ad >
   * fetch > missing ad.
   */


  if (!payload.ad && (payload.adId || payload.listId)) {
    /**
     * The response is either a local ad or a Promise for a ad. We have to avoid a Promise here if
     * we can.
     */
    var _fetchAd = (0, _fetchAd3["default"])(payload.adId, payload.listId),
        _fetchAd2 = _slicedToArray(_fetchAd, 2),
        status = _fetchAd2[0],
        _ad = _fetchAd2[1]; // eslint-disable-next-line no-unused-expressions


    status === 'fetching' ? _ad.then(function (newAd) {
      return addAdAndSend(event, payload, newAd);
    }) : addAdAndSend(event, payload, _ad);
  } else if (!window.dataLayer) {
    bufferedEvents.push(payload);
  } else {
    callImmediately(payload);
  }
};

exports.bufferIfNecessary = bufferIfNecessary;

var event = function event(payload) {
  return bufferIfNecessary('event', payload);
};

exports.event = event;

var engagement = function engagement(payload) {
  return bufferIfNecessary('engagement', payload);
};

exports.engagement = engagement;

var pageView = function pageView(payload) {
  return bufferIfNecessary('view', payload);
};

exports.pageView = pageView;

var update = function update(payload) {
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (merge) {
    persistentFields = _objectSpread(_objectSpread({}, persistentFields), payload);
  } else {
    persistentFields = payload || {};
  }

  return Object.keys(payload).reduce(function (obj, key) {
    obj[key] = undefined;
    return obj;
  }, {});
};
/**
 * There have been reports that safari will always give the wrong result when we do this despite
 * this being a example in specification on how to identify promises.
 *
 * It will be left here, unused, for a future iteration.
 */
// eslint-disable-next-line no-unused-vars


exports.update = update;

var isPromise = function isPromise(payload) {
  return Promise.resolve(payload) === payload;
};

var useEvent = function useEvent(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    /**
     * When we use `Promise.resolve` it will get resolved in the next browser tick which _can_ cause
     * problems in things like onClick handlers in exit links. If we want to avoid that we can do
     * this but there have been reports that `isPromise` function can give the wrong results in some
     * versions of safari.
     *
     * ```
     * const payload = payloadProvider()
     * isPromise(payload) ? payload.then(event) : event(payload)
     * ```
     */
    Promise.resolve(payloadProvider()).then(event);
  }, dependencies);
};

exports.useEvent = useEvent;

var useEngagement = function useEngagement(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(engagement);
  }, dependencies);
};

exports.useEngagement = useEngagement;

var usePageView = function usePageView(payloadProvider, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(pageView);
  }, dependencies);
};

exports.usePageView = usePageView;

var useUpdate = function useUpdate(payloadProvider, merge, dependencies) {
  return (0, _react.useEffect)(function () {
    Promise.resolve(payloadProvider()).then(function (payload) {
      return update(payload, merge);
    });
  }, dependencies);
};

exports.useUpdate = useUpdate;
//# sourceMappingURL=tracker.js.map